
// components/CryptoList.js
const CryptoList= ({ cryptos, onSelect }) =>{
  return (
    <table className="min-w-full bg-white overflow-scroll">
      <thead>
        <tr>
          <th className="py-2 px-4 border-b">Name</th>
          <th className="py-2 px-4 border-b">Symbol</th>
          <th className="py-2 px-4 border-b">Price (USD)</th>
          <th className="py-2 px-4 border-b">Market Cap</th>
          <th className="py-2 px-4 border-b">24h Change (%)</th>
        </tr>
      </thead>
      <tbody>
        {cryptos.map((crypto) => (
          <tr
            key={crypto.id}
            className="hover:bg-gray-100 cursor-pointer"
            onClick={() => onSelect(crypto)}
          >
            <td className="py-2 px-4 border-b flex items-center">
              <img src={crypto.image} alt={crypto.name} className="w-6 h-6 mr-2" />
              <span>{crypto.name}</span>
            </td>
            <td className="py-2 px-4 border-b">{crypto.symbol.toUpperCase()}</td>
            <td className="py-2 px-4 border-b">${crypto.current_price.toLocaleString()}</td>
            <td className="py-2 px-4 border-b">${crypto.market_cap.toLocaleString()}</td>
            <td
              className={`py-2 px-4 border-b ${
                crypto.price_change_percentage_24h >= 0 ? 'text-green-500' : 'text-red-500'
              }`}
            >
              {crypto.price_change_percentage_24h.toFixed(2)}%
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
export default CryptoList; 
